<template>
    <div class="loginBody">
        <div class="loginBox">
            <div class="loginLeft">
                <img src="../../assets/images/logo.png" />
            </div>
            <el-form
                :model="requestData"
                ref="loginForm"
                label-width="0"
                class="login_form"
            >
                <p>欢迎登录SCRM后台系统</p>
                <el-form-item
                    prop="phone"
                    :rules="[{ required: true, message: '手机号不能为空' }]"
                >
                    <el-input
                        type="text"
                        v-model.trim="requestData.phone"
                        placeholder="请输入手机号"
                    ></el-input>
                </el-form-item>
                <el-form-item
                    v-if="code"
                    prop="code"
                    :rules="[{ required: true, message: '验证码不能为空' }]"
                >
                    <el-input
                        type="text"
                        v-model="requestData.code"
                        placeholder="验证码"
                    >
                        <p
                            class="smsButton"
                            slot="append"
                            @click.prevent="getCode"
                            v-show="show"
                            :disabled="!show"
                        >
                            获取验证码
                        </p>
                        <p class="smsButton" v-show="!show" slot="append">
                            还剩余{{ count }} s
                        </p>
                    </el-input>
                </el-form-item>
                <el-form-item
                    v-else
                    prop="code"
                    :rules="[{ required: true, message: '密码不能为空' }]"
                >
                    <el-input
                        type="password"
                        v-model="requestData.code"
                        placeholder="密码"
                    >
                    </el-input>
                </el-form-item>
                <div class="loginButton" @click="submitForm('loginForm')">
                    登录
                </div>
                <div class="button bottom">
                    <p @click="scanCode">企业微信登录</p>
                    <p @click="code = !code">
                        {{ code ? '账号密码登录' : '账号验证码登录' }}
                    </p>
                </div>
            </el-form>
            <!-- 忘记密码 -->
            <!-- <el-form
        :model="forgetData"
        ref="forgetForm"
        label-width="0"
        class="login_form"
        v-else
      >
        <p>重置密码</p>
        <el-form-item
          class="form_item"
          prop="phone"
          :rules="[{ required: true, message: '手机号不能为空' }]"
        >
          <el-input
            type="text"
            v-model.trim="forgetData.phone"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="form_item"
          prop="code"
          :rules="[{ required: true, message: '验证码不能为空' }]"
        >
          <el-input
            type="text"
            v-model.trim="forgetData.code"
            placeholder="请输入验证码"
          >
            <p
              class="smsButton"
              slot="append"
              @click.prevent="getCode"
              v-show="show"
              :disabled="!show"
            >
              获取验证码
            </p>
            <p class="smsButton" v-show="!show" slot="append">
              还剩余{{ count }} s
            </p>
          </el-input>
        </el-form-item>
        <el-form-item
          class="form_item"
          prop="pass"
          :rules="[{ required: true, message: '请输入新密码' }]"
        >
          <el-input
            show-password
            v-model.trim="forgetData.pass"
            placeholder="请输入新密码"
          ></el-input>
        </el-form-item>
        <el-form-item
          class="form_item"
          prop="newPass"
          :rules="[{ required: true, message: '请确认密码' }]"
        >
          <el-input
            show-password
            v-model.trim="forgetData.newPass"
            placeholder="请确认密码"
          ></el-input>
        </el-form-item>
        <div class="loginButton" @click="submitForm('forgetForm')">登录</div>
        <div class="return" @click="forget = true">返回</div>
      </el-form> -->
        </div>
    </div>
</template>

<script>
import config from '../../config/index.js'
export default {
    name: 'Login',
    data() {
        return {
            show: true,
            count: '',
            timer: null,
            requestData: {
                phone: '',
                code: '',
                type: 1,
            },
            randCode: 4458,
            code: false,
        }
    },
    watch: {
        code(val) {
            this.requestData.code = ''
            if (val) this.requestData.type = 2
            else this.requestData.type = 1
        },
    },
    methods: {
        //扫码登录
        scanCode() {
            let redirectUrl = encodeURIComponent(
                window.location.origin + window.location.pathname
            )
            let url =
                'https://open.work.weixin.qq.com/wwopen/sso/3rd_qrConnect?appid=' +
                config.corpId +
                '&redirect_uri=' +
                redirectUrl +
                '&state=web_login@gyoss9&usertype=admin'
            location.href = url
        },
        submitForm(formName) {
            let _self = this
            _self.$commonFun.debounce(() => {
                _self.$refs[formName].validate((valid) => {
                    if (valid) {
                        let param = _self.requestData
                        _self.$api
                            .login(param)
                            .then((res) => {
                                _self.$store.dispatch('setToken', res.token)
                                _self.$store.commit('myStoreCur', res.merchant)
                                _self.$store.dispatch('temporaryClear')
                                _self.$commonFun.toast('登录成功', 'success')
                                _self.$commonFun.jumpPage('/')
                            })
                            .catch((errCode) => {
                                _self.fleshRand()
                            })
                    }
                })
            }, 500)
        },
        //更新验证码
        fleshRand() {
            let randCode = this.$commonFun.randCode(8, false)
            this.randCode = randCode
        },
        //获取验证码
        getCode() {
            if (this.requestData.phone.length === 11) {
                const TIME_COUNT = 60
                this.$api
                    .getLoginCode({
                        phone: this.forget
                            ? this.requestData.phone
                            : this.forgetData.phone,
                    })
                    .then((res) => {
                        if (!this.timer) {
                            this.count = TIME_COUNT
                            this.show = false
                            this.timer = setInterval(() => {
                                if (
                                    this.count > 0 &&
                                    this.count <= TIME_COUNT
                                ) {
                                    this.count--
                                } else {
                                    this.show = true
                                    clearInterval(this.timer)
                                    this.timer = null
                                }
                            }, 1000)
                        }
                    })
            } else {
                this.$message.error('请输入正确的手机号')
            }
        },
    },
}
</script>

<style lang="scss">
.loginBody {
    width: 100%;
    min-width: 1200px;
    height: 100vh;
    overflow: hidden;
    background: url('../../assets/images/bg.png') no-repeat center;
    background-size: cover;
    .loginBox {
        width: 803px;
        height: 529px;
        box-shadow: 0px 25px 66px 0px rgba(19, 73, 212, 0.34);
        margin: calc(50vh - 250px) auto;
        // background: rgba(255, 255, 255, 0.1);
        border-radius: 0 15px 0 15px;
        overflow: hidden;
        .loginLeft {
            background: #498ff7;
            // border: 2px solid;
            // border-image: linear-gradient(
            //         40deg,
            //         rgba(255, 255, 255, 0.5),
            //         rgba(255, 255, 255, 0)
            //     )
            //     2 2;
            // filter: blur(undefinedpx);
            box-sizing: border-box;
            width: 50%;
            height: 100%;
            float: left;
            display: flex;
            align-items: center;
            justify-content: center;
            // background: rgba(255, 255, 255, 0.01);
            // backdrop-filter: blur(2px);
            img {
                width: 107px;
                height: 141px;
            }
        }
        .login_form {
            width: 50%;
            float: left;
            background: #fff;
            height: 100%;
            padding: 70px 48px 80px;
            box-sizing: border-box;
            & > p {
                font-weight: bold;
                font-size: 24px;
                letter-spacing: 2px;
                margin-bottom: 30px;
            }
            .loginButton {
                width: 100%;
                margin: 50px auto 30px;
                padding: 14px 0;
                font-size: 16px;
                line-height: 18px;
                text-align: center;
                cursor: pointer;
                color: #ffffff;
                background-color: #4876ff;
                border-radius: 4px;
                font-weight: bold;
                letter-spacing: 5px;
            }
            .button {
                display: flex;
                font-size: 12px;
                color: #4876fe;
                &.top {
                    justify-content: end;
                }
                p {
                    cursor: pointer;
                    margin-right: 25px;
                    &:last-child {
                        margin-right: 0;
                    }
                }
            }
            .form_item {
                margin-bottom: 2px;
                .el-form-item__content {
                    border-bottom: 1px solid #eaeaea;
                    padding: 5px 0 5px;
                }
            }

            .el-form-item__content {
                border-bottom: 1px solid #eaeaea;
                padding: 5px 0 10px;
            }
            .el-form-item__error {
                margin: 5px 0 0 15px;
            }
            .el-input__inner {
                letter-spacing: 1px;
                border: none;
            }
            .el-input-group__append {
                background: none;
                border: none;
                padding: 0;
                .smsButton {
                    cursor: pointer;
                    border: 1px solid #4876ff;
                    border-radius: 20px;
                    color: #4876ff;
                    font-size: 12px;
                    width: 90px;
                    text-align: center;
                    line-height: 30px;
                }
            }
        }
    }
}
</style>
